import { render, staticRenderFns } from "./yearly_area_product.vue?vue&type=template&id=29e63afb&scoped=true"
import script from "./yearly_area_product.vue?vue&type=script&lang=js"
export * from "./yearly_area_product.vue?vue&type=script&lang=js"
import style0 from "./yearly_area_product.vue?vue&type=style&index=0&id=29e63afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e63afb",
  null
  
)

export default component.exports